<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HkoM2M/tc-custom/9781610583800.jpg?1704484106521" alt="This image is the cover for the book Herbaceous Perennial Plants"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Herbaceous Perennial Plants
      </h1>
      <p class="bookDescription body article font2">
        <b>The third edition of the comprehensive—and entertaining—gardening reference by the master horticulturalist.</b><br/><br/>This is the long-awaited third edition of Allan Armitage’s masterpiece on garden perennials. Armitage’s extensive traveling, teaching, and trialing experiences provide a depth of understanding of the best ornamental perennials for North American gardens unparalleled by any other garden writer. <br/><br/>One of the most definitive and conclusive books written about perennials, the first edition was designated as one of the best seventy-five books written in the last seventy-five years by the American Horticulture Society. Now the third edition of “The Big Perennial Book” (as it is fondly referred to by many practitioners) describes 3,600 species in 1224 pages. More than three hundred color photos complement detailed text filled with the author’s pointed observations of plant performance, cultivar selection, and current taxonomy. In addition, his trademark wit and passion are both in abundance, making reading as pleasurable as it is informative.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allan M. Armitage
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Georgia
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8d9c6b12